import React from 'react';
import Updates from '../updates';
import './index.css';
import CustomerReview from '../customerReview';

function RightSide() {

  return (
    <div className='right-side-container'>
        <div>
            <h3>Notificaciones</h3>
            <Updates/>
        </div>
        <div>
            <h3>FeedBack Usuarios</h3>
            <CustomerReview/>
        </div>
    </div>
  )
}

export default RightSide
